import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {CommonComponent} from '../../shared/common/common.component';
import {NavigationEnd, Router} from '@angular/router';
import {ApplicationService} from '../../../services/application.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {Application} from '../../../domain/onBoarding/application';
import {ApplicationBody} from '../../../domain/onBoarding/application-body';
import {Location} from '@angular/common';
import {ToastaService} from 'ngx-toasta';
import {TranslateService} from '@ngx-translate/core';
import {KycResult} from '../../../domain/onBoarding/kycResult';
import {EKycStatus} from '../../../enums/EKycStatus';
import {DialogService} from 'primeng/dynamicdialog';
import {filter} from 'rxjs/operators';
import {ConfigurationService} from "../../../services/configuration.service";

@Component({
  selector: 'app-additional-questions',
  templateUrl: './additional-questions.component.html',
  styleUrls: ['./additional-questions.component.scss']
})
export class AdditionalQuestionsComponent extends CommonComponent implements OnInit {

  @ViewChild('blackListedModal', {static: true}) blackListedModal: TemplateRef<any>;

  application: Application;
  previousUrl: string;

  constructor(
    protected router: Router,
    private applicationService: ApplicationService,
    private location: Location,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    public translate: TranslateService,
    protected dialogService: DialogService,
    protected configurationService: ConfigurationService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    this.application = this.applicationService.application;
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = event.urlAfterRedirects;
      }
    });
  }

  ngOnInit(): void {
    if (!this.application || !this.application.editing) {
      this.router.navigate(['/onboarding/']);
      return;
    }
  }

  onSubmit() {
    this.router.navigate(['/onboarding/end']);
  }


  onSubmitKyc() {
    this.loadingModalOn();
    let submit = true;
    if (this.isAmericanCitizen(this.application) && this.application.body.applicationRejected && this.configurationService.application.enableSelfieRequiered) {
      submit = false;
    }
    this.applicationService.submitKyc(this.application.body.applicationId, this.application.body.cipQuestions).subscribe(
      (kycResult: KycResult) => {
        this.application.body.kycStatus = kycResult.kycStatus;
        switch (kycResult.kycStatus) {
          case EKycStatus.APPROVED:
          case EKycStatus.MANUAL_REVIEW:
            if (this.application.body.applicationRejected) {
              this.applicationService.setApplication(submit).subscribe(
                (response: ApplicationBody) => {
                  this.application.body.cipQuestions = [];
                  this.application.body.status = response.status;
                  this.loadingModalOff();
                  if (this.isAmericanCitizen(this.application) && this.configurationService.application.enableSelfieRequiered){
                      this.router.navigate(['/onboarding/selfie']);
                  } else {
                    this.router.navigate(['/onboarding/end']);
                  }
                }, error => {
                  this.loadingModalOff();
                  this.msgError(error);
                }
              );
            } else {
              this.application.body.cipQuestions = [];
              this.loadingModalOff();
              if (this.isAmericanCitizen(this.application) && this.configurationService.application.enableSelfieRequiered){
                  this.router.navigate(['/onboarding/selfie']);
              } else {
                this.router.navigate(['/onboarding/contracts']);
              }
            }
            break;
          case EKycStatus.BLACK_LISTED:
            this.loadingModalOff();
            this.openModal(this.blackListedModal);
            break;
          case EKycStatus.PENDING_DOCUMENTS:
            this.application.body.cipQuestions = [];
            this.application.cipQ = false;
            this.loadingModalOff();
            this.router.navigate(['/onboarding/photos']);
            break;
          case EKycStatus.PENDING_QUESTIONS:
            this.application.body.cipQuestions = kycResult.cipResult.cipQuestions;
            this.loadingModalOff();
            break;
          default:
            this.loadingModalOff();
            this.msgError(this.translate.instant('onboarding.contracts-consents.error-try-again', {Default: 'Hubo un problema al generar su aplicación, por favor vuelva a intentarlo'}));
            break;
        }
      }, error => {
        this.msgError(error);
        this.loadingModalOff();
      }
    );
  }

  asIsOrder(a, b) {
    return 1;
  }

  onBack() {
    this.location.back();
  }

  onBlackListedBack() {
    this.application.body.cipQuestions = [];
    this.application.cipQ = false;
    this.router.navigate(['/onboarding/personalData']);
  }

  openModal(content: TemplateRef<any>): void {
    this.modalService.open(content, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
  }

}
